import React from 'react'
import nitin from './nitinv.jpg'
// import backgraund from './back.jpg'
import './FirstContent-style.css'

export default function FirstContent() {
  return (

    <>

      <div id="first">
        <div id='first-content'>
          <h1>Welcome To <b>Protonity</b></h1>
          <p className='slogan'>Be Positive And Innovative !</p>
          <p>" Hello Guys My Name Is <a href="https://www.instagram.com/nitinrathodofficial/" rel="noreferrer" target={'_blank'}>Nitin Rathod</a></p>
          <p>I'm Web-Developer And Programmer. and I Developed <b>Protonity</b> For Student Welfare. "</p>
          <div id="join-us">
            <h2>Protonity</h2>
            <div id="btn">
              <button >Start Learning</button>
              <button >Join Us</button>

            </div>

          </div>
        </div>
        <div id="first-image">
          <img src={nitin} alt="Nitin Ram Rathod" />
          <a href="https://www.instagram.com/nitinrathodofficial/" rel="noreferrer" target={'_blank'}>Mr. Nitin Rathod</a>



        </div>
      </div>
      <div id="second">
        <div id="expertise-info">
          <img src={nitin} alt="Nitin Rathod" />
          <div id="expertise-about">
            <p>About Myself</p>
            <p>&nbsp; &nbsp;&nbsp; <span>H</span>ello Friends My Name is <b>Nitin Ram Rathod</b> and I come From Jalna, Maharashtra. My Profession is Web Development.<br/> <br/>
              and I have Completed my BCA ( Bachelors's in Computer Application) from Jalna Education Society (JES), Jalna College 
              I will finish my Degree In The Year 2022, from Dr. Babasaheb Ambedkar Marathwada University, Aurangabad. <br /> 
              My Mobile Number Is <b>(+91)8459556244</b><br />
              and Email Id is <b>rathodni3ram4967@gmail.com</b></p>
          </div>
        </div>

        <div id="expertise">
          <div>
            <p>My Expertise In Following</p>
          </div>
          <div className="skills">
          <div className="bar">
            <div className="info">
              <span>HTML</span>
            </div>

            <div className="progress-line html"><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>CSS</span>
            </div>

            <div className="progress-line css"><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>JavaScript</span>
            </div>

            <div className="progress-line js" ><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>ReactJS</span>
            </div>

            <div className="progress-line react"><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>NodeJS</span>
            </div>

            <div className="progress-line node"><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>ExpressJS</span>
            </div>

            <div className="progress-line express"><span></span></div>
          </div>
          <div className="bar">
            <div className="info">
              <span>MongoDB</span>
            </div>

            <div className="progress-line mongodb"><span></span></div>
          </div>
          </div>

        

        </div>

      </div>


    </>

  )
}
